var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenInAnotherTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "open_in_new_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M121.556-826a1.5,1.5,0,0,1-1.1-.457,1.5,1.5,0,0,1-.457-1.1v-10.889a1.5,1.5,0,0,1,.457-1.1,1.5,1.5,0,0,1,1.1-.457H127v1.556h-5.444v10.889h10.889V-833H134v5.444a1.5,1.5,0,0,1-.457,1.1,1.5,1.5,0,0,1-1.1.457Zm3.656-4.122-1.089-1.089,7.233-7.233h-2.8V-840H134v5.444h-1.556v-2.8Z",
    transform: "translate(-120 840)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInAnotherTab);
export default __webpack_public_path__ + "static/media/openInAnotherTab.e8622e9df8fc24d7f24fb884471facad.svg";
export { ForwardRef as ReactComponent };